import { Button, Group, iconSizes, Stack, Text } from '@common/ui'
import { IconDownload } from '@common/ui/icons'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/web'
import EntityFieldDisplayGroup from '../shared/EntityFieldDisplayGroup'
import PageLayout from '../shared/PageLayout'
import { KindViewPageProps } from '../KindPages'
import useHasPermission from '../../../permission/useHasPermission'
import getResourceUrl from '../../../../io/api/resource/getResourceUrl'
import { getResourceKeyFromEntity } from '../../../../io/entityResourceKeyLink'
import useIsPublishable from '../asset/publish/useIsPublishable'
import PublishDialog from '../asset/publish/PublishDialog'
import VersionHistoryDrawer from '../asset/publish/VersionHistoryDrawer'
import usePublishStatus from '../asset/publish/usePublishStatus'
import PublishStatusChip from '../asset/publish/PublishStatusChip'
import EntityAction = com.eidu.entity.permission.EntityAction

const RuntimeViewPage = ({ entity, entityType, fields }: KindViewPageProps) => {
  const navigate = useNavigate()

  const { hasPermission: hasUpdatePermission } = useHasPermission(entity.entity.id, EntityAction.UpdateEntity)
  const { publishable } = useIsPublishable(entity, entityType)

  const navigateToEdit = () => {
    navigate(`/entities/${entityType.id.toString()}/edit/${entity.entity.id.toString()}`)
  }

  const resourceKey = getResourceKeyFromEntity(entity)
  const resourceUrl = resourceKey ? getResourceUrl(resourceKey) : undefined
  const publishStatus = usePublishStatus({ entity })

  return (
    <PageLayout
      title={entity.primaryLabelText}
      subtitle={entityType.name}
      auditTargetId={entity.entity.id.toString()}
      actions={
        <Group gap="xs">
          {publishable && (
            <>
              <PublishStatusChip status={publishStatus} entityType={entityType} currentResourceKey={resourceKey} />
              <PublishDialog entityId={entity.entity.id} />
              <VersionHistoryDrawer entityId={entity.entity.id} />
            </>
          )}
          {hasUpdatePermission && (
            <Button variant="subtle" onClick={navigateToEdit}>
              Edit
            </Button>
          )}
        </Group>
      }
      showBack
    >
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingTop: 12 }}>
        <EntityFieldDisplayGroup entityType={entityType} fields={fields} />
        {resourceUrl && (
          <Stack gap="xs" mt="md">
            <Text size="sm" fw={600}>
              Payload
            </Text>
            <Button
              variant="outline"
              leftSection={<IconDownload size={iconSizes.sm} stroke={1.5} />}
              component="a"
              href={resourceUrl}
              download
              style={{ alignSelf: 'flex-start' }}
            >
              Download
            </Button>
          </Stack>
        )}
      </div>
    </PageLayout>
  )
}

export default RuntimeViewPage
